// ======================================================================
// File Name       : ParticipantAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { SELECT_TARGET_DATA } from '../constants';
import { USER_CREATE_TYPE } from '../constants/UserConstants';
import * as participantActionCreators from './actionCreators/participant';
import * as GroupAction from './GroupAction';
import * as eachUserLiveCountRequest from './httpRequests/eachUserLiveCount';
import * as groupRequests from './httpRequests/group';
import * as participantRequest from './httpRequests/participant';
import * as usageSettingLiveRequest from './httpRequests/usageSettingLive';
import * as userRequest from './httpRequests/user';
import * as userAction from './UserAction';

export function searchParticipant(paramSearchInfo) {
  return async (dispatch, getState) => {
    let userSearchResult = { recordNum: 0, userList: [] };
    let groupRelationList = [];
    let eachUserLiveCountList = [];
    const userSecernIds = null;
    let groupInfo = {};
    await dispatch(userAction.getGroupListAll());
    groupInfo = getState().user.groupInfoAll;

    if (userSecernIds && userSecernIds.length) {
      paramSearchInfo.userSecernIdList = userSecernIds;
    }
    const searchInfo = paramSearchInfo;
    const userSearchRes = await fetchUser(searchInfo);
    if (userSearchRes && userSearchRes.userList && userSearchRes.userList.length) {
      userSearchResult = userSearchRes;
    }
    if (userSearchResult && userSearchResult.userList && userSearchResult.userList.length) {
      const searchGroupRelationInfo = {};
      searchGroupRelationInfo.userList = userSearchResult.userList.reduce((acc, cur) => {
        if (cur.userSecernId) {
          acc.push(cur.userSecernId);
        }
        return acc;
      }, []);
      if (searchGroupRelationInfo.userList && searchGroupRelationInfo.userList.length) {
        const groupRelationListRes = await groupRequests.postUserGroupRelationGetList({
          searchInfo: searchGroupRelationInfo,
        });
        if (groupRelationListRes && groupRelationListRes.groupRelationList) {
          groupRelationList = groupRelationListRes.groupRelationList;
        }
      }
      if (searchGroupRelationInfo.userList && searchGroupRelationInfo.userList.length) {
        const eachUserLiveCountListRes = await eachUserLiveCountRequest.eachUserLiveCount(
          searchGroupRelationInfo,
        );
        if (eachUserLiveCountListRes && eachUserLiveCountListRes.userList) {
          eachUserLiveCountList = eachUserLiveCountListRes.userList;
        }
      }
    }
    return dispatch(
      participantActionCreators.storeParticipantList(
        userSearchResult,
        groupRelationList,
        groupInfo,
        eachUserLiveCountList,
      ),
    );
  };
}

function fetchUser(searchInfo = {}) {
  return userRequest.postUserGetList({
    selectTargetData: SELECT_TARGET_DATA.DATA,
    searchInfo,
  });
}

export function getParticipantDetail(paramSearchInfo) {
  return async (dispatch, getState) => {
    let groupRelationList = [];
    const searchInfo = paramSearchInfo;
    const response = await userRequest.postUserGetList(searchInfo);
    await dispatch(GroupAction.fetchGroupStructure());
    const groupInfo = getState().group.structures;
    const searchGroupRelationInfo = {};
    if (response && response.userList && response.userList.length) {
      searchGroupRelationInfo.userList = response.userList.reduce((acc, cur) => {
        if (cur.userSecernId) {
          acc.push(cur.userSecernId);
        }
        return acc;
      }, []);
      if (searchGroupRelationInfo.userList && searchGroupRelationInfo.userList.length) {
        const groupRelationListRes = await groupRequests.postUserGroupRelationGetList({
          searchInfo: searchGroupRelationInfo,
        });
        if (groupRelationListRes && groupRelationListRes.groupRelationList) {
          groupRelationList = groupRelationListRes.groupRelationList;
        }
      }
    }
    return dispatch(
      participantActionCreators.storeParticipantDetail(
        response,
        groupRelationList,
        groupInfo,
      ),
    );
  };
}

export function getParticipantStatus(paramSearchInfo) {
  return async (dispatch) => {
    let liveList = [];
    let liverSearchResult = { recordNum: 0, liveStatusList: [] };
    const responseRelationStatus = await participantRequest.getRelationStatusList(paramSearchInfo);
    const liveStatusInfo = {
      includeCompletedLive: 1,
    };
    let organizerUserSecernIdList = [];
    let userSearchRes;
    if (responseRelationStatus && responseRelationStatus.liveStatusList && responseRelationStatus.liveStatusList.length) {
      liverSearchResult = responseRelationStatus;
      if (liverSearchResult && liverSearchResult.liveStatusList && liverSearchResult.liveStatusList.length) {
        liveStatusInfo.liveList = liverSearchResult.liveStatusList.reduce((acc, cur) => {
          if (cur.liveSecernId) {
            acc.push(cur.liveSecernId);
          }
          return acc;
        }, []);
        if (liveStatusInfo.liveList && liveStatusInfo.liveList.length) {
          const liveStatusListRes = await usageSettingLiveRequest.getLiveReservedList({ searchInfo: liveStatusInfo });
          if (liveStatusListRes && liveStatusListRes.liveList) {
            liveList = liveStatusListRes.liveList;
          }
          if (liveList && liveList.length) {
            organizerUserSecernIdList = liveList.reduce((acc, cur) => {
              if (cur.organizerUserSecernId) {
                acc.push(cur.organizerUserSecernId);
              }
              return acc;
            }, []);
            
            if (organizerUserSecernIdList && organizerUserSecernIdList.length) {
              const searchInfo = {
                userSecernIdList: organizerUserSecernIdList,
                userCreateType: USER_CREATE_TYPE.DEFINED_AND_REPRESENTATIVE_USER,
              };
              userSearchRes = await userRequest.postUserGetList({ searchInfo });
            }
          }
        }
      }
    }
    return dispatch(
      participantActionCreators.storeParticipantDetailStatus(
        liverSearchResult,
        liveList,
        liveStatusInfo,
        userSearchRes,
      ),
    );
  };
}

export function getParticipantStatusPaging(paramSearchInfo) {
  return async (dispatch) => {
    let liveList = [];
    let liverSearchResult = { recordNum: 0, liveStatusList: [] };
    const responseRelationStatus = await participantRequest.getRelationStatusList(paramSearchInfo);
    const liveStatusInfo = {
      includeCompletedLive: 1,
    };
    let organizerUserSecernIdList = [];
    let userSearchRes;
    if (responseRelationStatus && responseRelationStatus.liveStatusList && responseRelationStatus.liveStatusList.length) {
      liverSearchResult = responseRelationStatus;
      if (liverSearchResult && liverSearchResult.liveStatusList && liverSearchResult.liveStatusList.length) {
        liveStatusInfo.liveList = liverSearchResult.liveStatusList.reduce((acc, cur) => {
          if (cur.liveSecernId) {
            acc.push(cur.liveSecernId);
          }
          return acc;
        }, []);
        if (liveStatusInfo.liveList && liveStatusInfo.liveList.length) {
          const liveStatusListRes = await usageSettingLiveRequest.getLiveReservedList({ searchInfo: liveStatusInfo });
          if (liveStatusListRes && liveStatusListRes.liveList) {
            liveList = liveStatusListRes.liveList;
          }
          if (liveList && liveList.length) {
            organizerUserSecernIdList = liveList.reduce((acc, cur) => {
              if (cur.organizerUserSecernId) {
                acc.push(cur.organizerUserSecernId);
              }
              return acc;
            }, []);
            
            if (organizerUserSecernIdList && organizerUserSecernIdList.length) {
              const searchInfo = {
                userSecernIdList: organizerUserSecernIdList,
              };
              userSearchRes = await userRequest.postUserGetList({ searchInfo });
            }
          }
        }
      }
    }
    return dispatch(
      participantActionCreators.storeParticipantDetailStatus(
        liverSearchResult,
        liveList,
        liveStatusInfo,
        userSearchRes,
      ),
    );
  };
}
// #7129 START
export function resetParticipantDetail() {
  return async dispatch => dispatch(participantActionCreators.resetParticipantDetail());
}
// #7129 END
